import React from 'react'
import { Col, Row, Input, Select } from 'antd'
const { Option } = Select
const { Search } = Input

function CashRegisterTabsHeader(props) {
  return (
    <Row gutter={16}>
      <Col xs={7} sm={7} md={7} lg={7}>
        <Select
          value={props.selectedOption}
          className={'single-select'}
          placeholder={'Selecciona una tienda'}
          size={'large'}
          style={{ width: '100%' }}
          onChange={option => {
            props.setSelectedOption(option)
          }}
        >
          {props.shopsList?.map(option => (
            <Option key={option.id} value={option.id}>
              {option.name}
            </Option>
          ))}
        </Select>
      </Col>
      <Col xs={11} sm={11} md={11} lg={11}>
        {props.search && !!props.selectedOption && (
          <Search
            placeholder="Buscar por número de boleta"
            className={'tendero-table-search custom-search'}
            size={'large'}
            onSearch={props.onSearch}
          />
        )}
      </Col>
    </Row>
  )
}

export default CashRegisterTabsHeader
